import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddEditSolarForm, AdditionalSettingsFileExtension, HomePageContents, SupplierDetails } from '../shared/models/admin.model';
import { DataSourceService } from './data-source.service';
import { UsersDetail } from '../shared/models/user.model';

@Injectable({
  providedIn: 'root'
})

export class AdminRepositoryService {

  constructor(private dataSource: DataSourceService) { }
  
  getAllUsers(): Observable<UsersDetail[]> {
    return this.dataSource.getAllUsers();
  }

  getUserById(id: string): Observable<any> {
    return this.dataSource.getUserById(id);
  }

  uploadStaticFile(data:FormData): Observable<any> {
    return this.dataSource.uploadStaticFile(data);
  }

  uploadPPAPContent(data:FormData): Observable<any> {
    return this.dataSource.uploadPPAPContent(data);
  }

  removePPAPContentFile(fileName:string,  ppapNum: string): Observable<any> {
    return this.dataSource.removePPAPContentFile(fileName,ppapNum);
  }

  uploadComplienceDocumentFile(data:FormData): Observable<any> {
    return this.dataSource.uploadComplienceDocumentFile(data);
  }
 
  removeStaticContentFile(data: any): Observable<any> {
    return this.dataSource.removeStaticContentFile(data);
  }

  removeUploadComplienceDocumentFile(sectionId:string, fileName:string): Observable<any> {
    return this.dataSource.removeUploadComplienceDocumentFile(sectionId, fileName);
  }

  getStaticContentForCompliance(data:string): Observable<HomePageContents> {
    return this.dataSource.getStaticContentForCompliance(data);
  }
  //getHomeSectionFile
 getHomeSectionFile(fileName: string): Observable<Blob> {
    return this.dataSource.getHomeSectionFile(fileName);
  }
getComplianceFile(fileName: string): Observable<Blob> {
    return this.dataSource.getComplianceFile(fileName);
  }
  getAllHomePageConents(data:string): Observable<HomePageContents> {
    return this.dataSource.getAllHomePageStaticConents(data);
  }

  saveStaticContent(contentForm: HomePageContents): Observable<any> {
    return this.dataSource.saveStaticContent(contentForm);
  }

  uploadStaticContent(uploadDocument): Observable<any> {
    return this.dataSource.uploadStaticContent(uploadDocument);
  }
  
  editStaticContent(data): Observable<any> {
    return this.dataSource.editStaticContent(data);
  }

  getSolarFormConents(): Observable<AddEditSolarForm> {
    return this.dataSource.getSolarFormConents();
  }

  saveSolarForm(contentForm: FormData): Observable<any> {
    return this.dataSource.saveSolarForm(contentForm);
  }

  updateSolarForm(contentForm: FormData): Observable<any> {
    return this.dataSource.updateSolarForm(contentForm);
  }

  exportSupplierData(filter: string): Observable<Blob> {
    return this.dataSource.exportSupplierData(filter);
  }

  setfileSize(fileSize: Number): Observable<Number> {
    return this.dataSource.setfileSize(fileSize);
  }

  getfileSize(): Observable<Number> {
    return this.dataSource.getfileSize();
  }
  

  getfileExtension(): Observable<any> {
    return this.dataSource.getfileExtension();
  }

  updateFileExtension(updateAppConfig: AdditionalSettingsFileExtension): Observable<any> {
    return this.dataSource.updateFileExtension(updateAppConfig);
  }

}
